module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.sass
// module id = ./src/app/common/footer/footer.component.sass
// module chunks = main